import React from 'react';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import styles from './SchoolSeatsFilled.scss';

const SchoolSeatsFilled = ({ used, total }) => {
  return (
    <div className="SchoolSeatsFilled">
      <ConnectedFormattedMessage
        id="users_list.seats_filled"
        values={{
          seats_filled: <div className="SchoolSeatsFilled__value">{used}</div>,
          total: <div className="SchoolSeatsFilled__value">{total}</div>,
        }}
      />
    </div>
  );
};

export default SchoolSeatsFilled;
